import { gql } from '@apollo/client'

export const GET_DASHBOARD = gql`
  query GetDashboard($input: DashboardInput!) {
    dashboard(input: $input) {
      storesCount
      storesNeedAudits
      storesNoImages
    }
  }
`
